import { motion } from "framer-motion";
import { ConnectionLogo } from "../DataSourcesList";
import classNames from "classnames";
import { ReactNode } from "react";
import GustoIcon from "static/images/GustoIcon.svg";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { GUSTO } from "constants/dataSource";

export const GustoCard = ({
  tag,
  name,
  description,
  isAddCard = false,
}: {
  tag: ReactNode;
  name: ReactNode;
  description: ReactNode;
  isAddCard?: boolean;
}) => {
  const { url } = useRouteMatch();
  const { search } = useLocation();
  const history = useHistory();

  return (
    <>
      <button
        className="all:unset"
        onClick={() => history.push(`${url}/${GUSTO}${search}`)}
      >
        <motion.div
          layout
          className={classNames(
            "t-flex t-flex-col t-flex-1 t-items-center t-p-9 hover:t-shadow-light-100 t-shadow-light-30 t-rounded-lg t-relative t-overflow-visible t-min-h-[310px]  t-h-full t-transition-shadow",
            {
              " t-bg-i-s t-border t-border-dashed t-border-i-neutral-10 t-bg-surface-lighter-grey":
                isAddCard,
              "t-bg-surface": !isAddCard,
            }
          )}
        >
          <ConnectionLogo logoUrl={GustoIcon} />
          <div className="t-mt-4 t-flex t-flex-col t-gap-2 t-justify-between t-items-center">
            <div
              className={classNames("", {
                "t-visible": tag,
                "t-invisible": !tag,
              })}
            >
              {tag}
            </div>
            <span className="t-text-subtitle-sm t-text-text-60">{name}</span>
            {description && (
              <span className="t-text-body-sm t-text-purple-55 t-text-center">
                {description}
              </span>
            )}
          </div>
        </motion.div>
      </button>
    </>
  );
};
